// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2lpAq","head":"Table_head__2Fwt6","col":"Table_col__1m4__"};